import { render, staticRenderFns } from "./PartiesView.vue?vue&type=template&id=643a2a30&scoped=true"
import script from "./PartiesView.vue?vue&type=script&lang=js"
export * from "./PartiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a2a30",
  null
  
)

export default component.exports